import {Component, NgZone} from '@angular/core';
import {IonicPage, NavController, Platform} from 'ionic-angular';

import {ProofOnWebPage} from '../proof-on-web/proof-on-web';
import {ProofOnAppPage} from '../proof-on-app/proof-on-app';

import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {AlertProvider} from '../../providers/alert/alert';
import {ProofProvider} from '../../providers/proof/proof';
import {ProofServerProvider} from '../../providers/proof-server/proof-server';
import {Storage} from "@ionic/storage";
import {DateTimeProvider} from "../../providers/datetime/datetime";

/**
 * Generated class for the ProofBeforeBeginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-before-begin',
  templateUrl: 'proof-before-begin.html',
})
export class ProofBeforeBeginPage {

  duration: number;
  durationMinima: string;
  durationMinutos: number;

  hours: string;
  minutes: string;

  advice: string;
  isPlugged: boolean = false;
  isOnline: boolean = false;

  public acceptedTerms: boolean = false;

  constructor(
    private navCtrl: NavController,
    private networkMonitor: NetworkMonitorProvider,
    private zone: NgZone,
    private platform: Platform,
    private alertProvider: AlertProvider,
    private proof: ProofProvider,
    private proofServer: ProofServerProvider,
    private storage: Storage,
    private dateTimeProvider: DateTimeProvider,
  ) {
    let that = this;
    this.duration = 0;
    this.durationMinutos = 0;
    this.hours = '00';
    this.minutes = '00';

    proof.getDuration().then((duration: any): void => {
      that.duration = Math.round(duration / 60);
    });

    this.durationMinima = proof.getDurationMin();
    this.advice = proof.getAdvice();

    let a: string[] = this.durationMinima.split(':');
    this.durationMinutos = (+a[0]) * 60 * 60 + (+a[1]);

    this.hours = a[0];
    this.minutes = a[1];

    if ((this.platform.is('cordova')) && (!this.platform.is('ios'))) {

      // Network Stuff
      this.isOnline = networkMonitor.isOnline();
      this.networkMonitor.setCallback(function (isOnline, isWifi, isAirplaneMode): void {
        that.zone.run(() => {
          that.isOnline = isOnline;
          console.log('ProofBeforeBeginPage - Online: ' + (isOnline ? 'Y' : 'N'));
        });
      });
    } else {
      this.isPlugged = true;
      this.isOnline = true;
    }
  }

  public ionViewDidLoad(): void {
    setTimeout((): void => {
      const title: string = 'Aceite dos Termos de Uso e Regras do Exame';
      let message: string = '<p>Antes de prosseguir com o exame, por favor, leia e aceite os termos abaixo:</p> <ol> <li><strong>Compromisso e Aceitação:</strong> Ao aceitar, você se compromete a cumprir todas as regras do edital e regulamento fornecidos no Edital da prova de Certificação.</li> <li><strong>Responsabilidade Civil: Você será responsabilizado(a) civilmente por quaisquer violações, incluindo: <ul> <li>Reembolso dos custos decorrentes de inativação e substituição de questões comprometidas.</li> <li>Pagamento de multa de R$ 5.000,00 por cada violação identificada.</li> </ul></li> <li><strong>Responsabilidade Criminal:</strong> Ação judicial poderá ser tomada em casos de crimes como falsidade ideológica ou violação de direitos autorais.</li> <li><strong>Monitoramento e Evidências: O sistema coletará imagens e gravações durante o exame. Qualquer manipulação ou violação das regras de integridade poderá resultar em penalidades severas.</strong></li> </ol> <p><strong>Clique em "Aceitar" se você concorda com todos os termos e condições acima.</strong></p>';

      this.alertProvider.doConfirm(message, (): void => {
        this.alertProvider.doWaiting('Registrando...');
        this.proofServer.termsAcceptance(this.proof.getId()).subscribe({
          next: (): void => {
            this.acceptedTerms = true;
            this.alertProvider.doWaitingHide();
          },
          error: (err: any): void => {
            console.error(err);
            this.alertProvider.doWaitingHide();
          }
        });
      }, null, 'Aceitar', 'Não Aceitar', title, 'alert-lg');
    }, 100);
  }

  public goBack(): void {
    this.navCtrl.pop();
  }

  public startProof(): void {
    let that = this;
    let message: string = 'Recomendamos fortemente que feche todas as abas do seu navegador e qualquer outro aplicativo.<br /><br />Sair da aba da prova, caracterizará como inconformidade e você poderá ser reprovado por isso.';

    this.alertProvider.doAlert(message, 'OLÁ', (): void => {
      let message: string = 'Sua prova será iniciada e a partir deste momento você não poderá mais sair da frente do computador.<br /><br />Aproveite este tempo antes de iniciar para ir ao banheiro e que tenham tenha água para se hidratar durante a prova.<br /><br />Boa prova!';

      that.alertProvider.doConfirm(message, (): void => {
        that.goToProof();
      });
    }, 'Prosseguir');
  }

  private goToProof(): void {
    let that = this;

    // TODO: Verify if using airplane mode
    this.proof.resetQuestions().then((): void => {
      if (that.platform.is('cordova')) {
        that.navCtrl.push(ProofOnAppPage);
      } else {
        that.navCtrl.push(ProofOnWebPage);
      }

      //"{"id":"1591213283535","kind":"MV","name":null,"questionId":null,"note":null,"base64":null,"contentOrPath":"file:///storage/emulated/0/DCIM/Camera/VID_20200603_194118.mp4","captured":"2020-06-03T19:41:23+00:00","seconds":null,"secondsRemaining":null,"extra":null}"
      let dataStartProof: string = this.dateTimeProvider.getISOString();
      //initProofDate =  this.dateTimeProvider.getISOString(),
      //   {
      //     "id":this.dateTimeProvider.getString(),
      //     "kind":"POS",
      //     "name":null,
      //     "questionId":null,
      //     "note":null,
      //     "base64":null,
      //     "contentOrPath":null,
      //     "captured"
      //     "seconds":null,
      //     "secondsRemaining":null,
      //     "extra":null
      //   }
      // ;
      this.storage.set('userproof_' + this.proof.getId() + '_atStartProof', dataStartProof);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/proof-before-begin/proof-before-begin.ts